import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
//import { DownloadService } from '@data/download.service';
import { ICellRendererParams } from 'ag-grid-community';
import { OrderDialogService } from '../../order-dialog.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-fill-document',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  template: `
  <div style="text-align:center;">
      <button mat-icon-button *ngIf="canFill"
        (click)="clicked()">
        <mat-icon>edit</mat-icon>
      </button>
  </div>
`
})
export class FillDocumentComponent implements OnInit {

  id: any;
  docId: any;
  canFill = false;
  type = '';
  url = '';
  _data: any;

  @Output() done = new EventEmitter<boolean>();

  @Input() set data(data: any) {
    if (data) {
      this.setData(data, '');
    }
  }

  constructor(
    private dialogService: OrderDialogService
  ) { }

  ngOnInit(): void {
  }

  setData(d: any, url: string) {

    this._data = d;

    if (d?.orderId) {
      this.id = d.orderId;
    }

    this.url = '/montage/documents/' + this.id;

    if (d?.id) {
      this.docId = d.id;
      this.url += '/' + d.id;
    }

    this.url += '/edit';

    this.canFill = !!d?.canfill;

    if (url) {
      this.url = url;
    }
  }

  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    this.setData(params?.data, params?.colDef?.cellRendererParams?.url);
  }

  clicked() {
    const res = this.dialogService.openDialog(
      this.id,
      this.docId,
      this._data
    );

    if (res) {
      const sub: any = {
        value: null
      };

      sub.value = res.subscribe((result: any) => {
        if (result?.success) {
          this.done.emit(true);
        }
        sub.value && sub.value.unsubscribe();
      });
    }
    /*
    return;

    const show = (b: Blob) => {
      const res = this.dialogService.openDialog(this.id, this.docId, b);

      MyLog.log('SHOW:', res);
      if (res) {
        const sub: any = {
          value: null
        };

        sub.value = res.subscribe((result: any) => {
          MyLog.log('CLOSED', result);
          if (result?.success) {
            this.done.emit(true);
          }
          sub.value && sub.value.unsubscribe();
        });

      }
    };

    sub.sub = this.downloadService.downloadRaw(
      this.url,
      show
    ).subscribe((res: Download) => {
      if (res?.state === 'DONE' && sub.sub) {
        sub.sub.unsubscribe();
        sub.sub = null;
      }
    });
    */
  }
}
